import { render } from "./body.vue?vue&type=template&id=53305319"
import script from "./body.vue?vue&type=script&lang=js"
export * from "./body.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__